import { render, staticRenderFns } from "./carrier-dashboard.vue?vue&type=template&id=cdcf636c&scoped=true&"
import script from "./carrier-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./carrier-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./carrier-dashboard.scss?vue&type=style&index=0&id=cdcf636c&lang=scss&scoped=true&"
import style1 from "./carrier-dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf636c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdcf636c')) {
      api.createRecord('cdcf636c', component.options)
    } else {
      api.reload('cdcf636c', component.options)
    }
    module.hot.accept("./carrier-dashboard.vue?vue&type=template&id=cdcf636c&scoped=true&", function () {
      api.rerender('cdcf636c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/carrier-dashboard/carrier-dashboard.vue"
export default component.exports